import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { BulkCreateDraftsTaskItem } from '../BulkCreateDraftsTaskItem/BulkCreateDraftsTaskItem';
import { BulkSendProposalsTaskItem } from '../BulkSendProposalsTaskItem/BulkSendProposalsTaskItem';
import { RelationshipPdfTaskItem } from '../RelationshipPdfTaskItem/RelationshipPdfTaskItem';
export const GetTaskItemTID = (parentTestId)=>getTestIds(parentTestId);
export const TaskItem = (param)=>{
    let { task, cancelTask } = param;
    const { TaskItemTID } = useMemo(()=>GetTaskItemTID(task.jobId), [
        task.jobId
    ]);
    switch(task.kind){
        case 'relationshipPdf':
            return /*#__PURE__*/ _jsx(RelationshipPdfTaskItem, {
                task: task,
                cancelTask: cancelTask,
                testId: TaskItemTID.Root()
            });
        case 'bulkSendProposals':
            return /*#__PURE__*/ _jsx(BulkSendProposalsTaskItem, {
                task: task,
                testId: TaskItemTID.Root()
            });
        case 'bulkCreateDrafts':
            return /*#__PURE__*/ _jsx(BulkCreateDraftsTaskItem, {
                task: task,
                testId: TaskItemTID.Root()
            });
        default:
            {
                const _exhaustive = task;
                return _exhaustive;
            }
    }
};
